"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeCursorInTrailingParagraph = exports.deleteSelectedRange = exports.deletePreviousBlock = exports.singleLineBreak = exports.newParagraphBelow = void 0;
var slate_1 = require("slate");
var LineBreak_1 = require("ContentTokens/DataModels/LineBreak");
var Utils_1 = require("../Utils");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var Paragraph_1 = require("../WidgetRegistry/Widgets/Paragraph");
var tiny_invariant_2 = __importDefault(require("tiny-invariant"));
var slate_react_1 = require("slate-react");
var newParagraphBelow = function (editor) {
    slate_1.Transforms.splitNodes(editor, { always: true });
    slate_1.Transforms.unsetNodes(editor, "style");
    slate_1.Transforms.setNodes(editor, (0, Paragraph_1.createParagraphNode)());
};
exports.newParagraphBelow = newParagraphBelow;
var singleLineBreak = function (editor) {
    if (!editor.selection) {
        return;
    }
    slate_1.Transforms.insertNodes(editor, LineBreak_1.lineBreak.createSlateJson());
    var textEntry = (0, Utils_1.getNext)(editor, editor.selection.anchor.path, slate_1.Text.isText);
    if (!!textEntry) {
        slate_1.Transforms.select(editor, { path: textEntry[1], offset: 0 });
    }
};
exports.singleLineBreak = singleLineBreak;
var deletePreviousBlock = function (editor) {
    if (!editor.selection) {
        return;
    }
    var previousBlockEntry = (0, Utils_1.getPrevious)(editor, slate_1.Range.start(editor.selection).path, Utils_1.isBlockElement);
    if (previousBlockEntry) {
        slate_1.Transforms.removeNodes(editor, { at: previousBlockEntry[1] });
    }
};
exports.deletePreviousBlock = deletePreviousBlock;
var deleteSelectedRange = function (editor, direction) {
    var _a, _b;
    if (direction === void 0) { direction = "backward"; }
    var selection = editor.selection;
    if (!slate_1.Range.isRange(selection)) {
        return;
    }
    var _c = __read(slate_1.Range.edges(selection), 2), start = _c[0], end = _c[1];
    var commonAncestorPath = slate_1.Path.common(start.path, end.path);
    var _d = __read(slate_1.Editor.node(editor, commonAncestorPath), 2), node = _d[0], path = _d[1];
    var startBlock = (0, Utils_1.getClosestBlock)(editor, start.path);
    var endBlock = (0, Utils_1.getClosestBlock)(editor, end.path);
    (0, tiny_invariant_1.default)(startBlock, "couldn't get start block of selection");
    (0, tiny_invariant_1.default)(endBlock, "couldn't get end block of selection");
    var startBlockIsText = ((_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(startBlock[0].type)) === null || _a === void 0 ? void 0 : _a.nodeType) === "textElement";
    var endBlockIsText = ((_b = (0, EditorWidgetRegistry_1.getGenericConfigByType)(endBlock[0].type)) === null || _b === void 0 ? void 0 : _b.nodeType) === "textElement";
    var startAndEndBlocksAreSameOrSiblings = slate_1.Path.equals(startBlock[1], endBlock[1]) || slate_1.Path.isSibling(startBlock[1], endBlock[1]);
    if (startBlockIsText && endBlockIsText && startAndEndBlocksAreSameOrSiblings) {
        slate_1.Transforms.delete(editor, { at: { anchor: start, focus: end } });
        return;
    }
    (0, tiny_invariant_1.default)(!slate_1.Text.isText(node), "node is text but it should already be deleted");
    var finalCursorPointRef = slate_1.Editor.pointRef(editor, start);
    var backupFinalCursorPointRef;
    var backupTextNode = direction === "backward"
        ? slate_1.Editor.previous(editor, { at: start, mode: "all", voids: true, match: slate_1.Text.isText })
        : slate_1.Editor.next(editor, { at: end, mode: "all", voids: true, match: slate_1.Text.isText });
    if (backupTextNode) {
        backupFinalCursorPointRef =
            direction === "backward"
                ? slate_1.Editor.pointRef(editor, slate_1.Editor.end(editor, backupTextNode[1]))
                : slate_1.Editor.pointRef(editor, slate_1.Editor.start(editor, backupTextNode[1]));
    }
    var deleteContent = function (node, path) {
        var e_1, _a;
        var _b;
        if (!slate_1.Editor.isEditor(node)) {
            var nodeStart = slate_1.Editor.start(editor, path);
            var nodeEnd = slate_1.Editor.end(editor, path);
            if (node.type === "accordion" && !node.data.expanded) {
                nodeStart = slate_1.Editor.start(editor, __spreadArray(__spreadArray([], __read(path), false), [0], false));
                nodeEnd = slate_1.Editor.end(editor, __spreadArray(__spreadArray([], __read(path), false), [0], false));
            }
            var nodeStartWithinSelection = [-1, 0].includes(slate_1.Point.compare(start, nodeStart));
            var nodeEndWithinSelection = [0, 1].includes(slate_1.Point.compare(end, nodeEnd));
            var isFullySelected = nodeStartWithinSelection && nodeEndWithinSelection;
            var isStandalone = !(0, EditorWidgetRegistry_1.isContainerManagedWidget)(node.type);
            var isTextElement = ((_b = (0, EditorWidgetRegistry_1.getGenericConfigByType)(node.type)) === null || _b === void 0 ? void 0 : _b.nodeType) === "textElement";
            if (isFullySelected && isStandalone) {
                slate_1.Transforms.delete(editor, { at: path });
                return;
            }
            if (!isFullySelected && isTextElement) {
                slate_1.Transforms.delete(editor, {
                    at: {
                        anchor: nodeStartWithinSelection ? nodeStart : start,
                        focus: nodeEndWithinSelection ? nodeEnd : end,
                    },
                });
                return;
            }
        }
        var startChild;
        var endChild;
        var middleChildren = [];
        for (var childIndex = 0; childIndex <= node.children.length - 1; childIndex++) {
            var child = node.children[childIndex];
            var childPath = __spreadArray(__spreadArray([], __read(path), false), [childIndex], false);
            var childRange = slate_1.Editor.range(editor, childPath);
            if (slate_1.Range.includes(childRange, start)) {
                startChild = [child, childPath];
            }
            if (slate_1.Point.isAfter(end, childRange.focus) && slate_1.Point.isBefore(start, childRange.anchor)) {
                middleChildren.push([child, childPath]);
            }
            if (slate_1.Range.includes(childRange, end)) {
                endChild = [child, childPath];
            }
        }
        try {
            for (var _c = __values(__spreadArray(__spreadArray(__spreadArray([], __read((0, CommonUtils_1.includeIf)(!!endChild, [endChild])), false), __read(middleChildren.reverse()), false), __read((0, CommonUtils_1.includeIf)(!!startChild, [startChild])), false)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var child = _d.value;
                (0, tiny_invariant_1.default)(!slate_1.Text.isText(child[0]), "".concat(child[0], " is a text node when we weren't expecting one"));
                deleteContent(child[0], child[1]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return;
    };
    deleteContent(node, path);
    var finalCursorPoint = finalCursorPointRef.unref();
    var backupFinalCursorPoint = backupFinalCursorPointRef === null || backupFinalCursorPointRef === void 0 ? void 0 : backupFinalCursorPointRef.unref();
    if (finalCursorPoint) {
        slate_1.Transforms.select(editor, finalCursorPoint);
    }
    else if (backupFinalCursorPoint) {
        slate_1.Transforms.select(editor, backupFinalCursorPoint);
    }
    else if (direction === "backward") {
        slate_1.Transforms.select(editor, slate_1.Editor.start(editor, []));
    }
    else if (direction === "forward") {
        slate_1.Transforms.select(editor, slate_1.Editor.end(editor, []));
    }
    return true;
};
exports.deleteSelectedRange = deleteSelectedRange;
var placeCursorInTrailingParagraph = function (editor) {
    var lastEntry = slate_1.Editor.node(editor, [editor.children.length - 1]);
    var lastNode = lastEntry[0];
    var lastPath = lastEntry[1];
    (0, tiny_invariant_2.default)(slate_1.Element.isElement(lastNode), "last node in an editor should be an element");
    var config = (0, EditorWidgetRegistry_1.getConfigByType)(lastNode.type);
    if (config.nodeType !== "textElement" || !slate_1.Editor.isEmpty(editor, lastNode)) {
        lastPath = slate_1.Path.next(lastPath);
        slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), { at: lastPath });
    }
    slate_1.Transforms.select(editor, slate_1.Editor.start(editor, lastPath));
    slate_react_1.ReactEditor.focus(editor);
};
exports.placeCursorInTrailingParagraph = placeCursorInTrailingParagraph;
